import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  ListItemText,
} from "@mui/material";
import { Phone, CheckCircle } from "@mui/icons-material";
import { sendMailTo } from "../../Services/SmsService";
import { useSelector } from "react-redux";

const dummyBanks = [
  { id: 1, name: "HDFC Bank", email: "hdfc@example.com" },
  { id: 2, name: "ICICI Bank", email: "icici@example.com" },
  { id: 3, name: "SBI Bank", email: "sbi@example.com" },
  { id: 4, name: "Axis Bank", email: "axis@example.com" },
];

const LoanEnquiryModal = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [consent, setConsent] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [pan, setPan] = useState("");
  const [panError, setPanError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [selectedBanks, setSelectedBanks] = useState([]);

  // const handleSubmit = () => {
  //   if (!mobileNumber || !pan || !consent) {
  //     setPanError("Please fill in all fields and consent.");
  //     return;
  //   }
  //   setLoading(true);
  //   setTimeout(() => {
  //     setLoading(false);
  //     setSubmitted(true);
  //   }, 2000);
  // };

  const loggedInUser = useSelector((state) => state.Auth.user);
  const customerEmail = loggedInUser?.personId?.email;
  const customerName = loggedInUser?.personId?.name || "Customer";
  console.log("customerEmail", customerEmail, customerName);
  const handleSubmit = async () => {
    if (!mobileNumber || !pan || !consent) {
      setPanError("Please fill in all fields and consent.");
      return;
    }

    setLoading(true);

    try {
      const bankEmail = "aishwarya.nimbalkar@payasystems.com"; // later make dynamic

      // 📩 Email to Customer
      await sendMailTo({
        to: [customerEmail],
        subject: "Loan Enquiry Submitted Successfully",
        message: `
        <p>Dear ${loggedInUser?.personId?.firstName || "Customer"},</p>
        <p>Your loan enquiry has been successfully submitted.</p>
        <p><b>Mobile:</b> ${mobileNumber}</p>
        <p><b>PAN:</b> ${pan}</p>
        <p>Our trusted banking partner will contact you shortly.</p>
        <br/>
        <p>Regards,<br/>Team</p>
      `,
      });

      // 📩 Email to Bank
      await sendMailTo({
        to: [bankEmail],
        subject: "New Loan Enquiry Received",
        message: `
        <p><b>New Loan Enquiry</b></p>
        <p><b>Customer Name:</b> ${customerName}</p>
        <p><b>Customer Email:</b> ${customerEmail}</p>
        <p><b>Mobile:</b> ${mobileNumber}</p>
        <p><b>PAN:</b> ${pan}</p>
      `,
      });

      setSubmitted(true);
    } catch (error) {
      console.error("Email Error:", error);
    }

    setLoading(false);
  };

  const handleClose = () => {
    setSubmitted(false);
    setMobileNumber("");
    setPan("");
    setConsent(false);
    onClose();
  };

  const handlePanChange = (e) => {
    const val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""); // Format PAN to upper case and remove non-alphanumeric characters
    setPan(val);

    // PAN number validation regex: 5 letters + 4 digits + 1 letter
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (val && !panRegex.test(val)) {
      setPanError("Invalid PAN format. Example: ABCDE1234F");
    } else {
      setPanError("");
    }
  };
  const handleMobileChange = (e) => {
    const val = e.target.value;

    setMobileNumber(val);

    // Mobile number validation regex: starts with 6, 7, 8, or 9, followed by 9 digits
    const mobileRegex = /^[6789]\d{9}$/;
    if (val && !mobileRegex.test(val)) {
      setMobileError("Invalid mobile number. Please enter a 10-digit number.");
    } else {
      setMobileError("");
    }
  };

  return (
    <Modal
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "auto",
        p: 1,
      }}
      open={open}
      onClose={handleClose}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "auto",
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 3,
          maxWidth: 600,
          width: "100%",
          boxShadow: 24,
        }}
      >
        <Box sx={{ width: "100%" }}>
          {!submitted ? (
            <>
              {/* Header Bar */}
              <Box
                sx={{
                  bgcolor: "#1570ef",
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 1,
                  fontFamily: '"Inter", sans-serif', // Specific font
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: 40,
                    height: 40,
                    bgcolor: "white",
                    borderRadius: 1,
                  }}
                >
                  <Phone sx={{ color: "#1570ef", fontSize: 20 }} />
                </Box>
                <Box sx={{ ml: 2 }}>
                  <Typography
                    variant="h6"
                    sx={{ color: "white", fontWeight: 600, fontSize: "20px" }}
                  >
                    Loan Enquiry
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "white", opacity: 0.8, fontSize: "14px" }}
                  >
                    Our trusted banking partners will contact you shortly
                  </Typography>
                </Box>
              </Box>

              {/* Security Info */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F5F5F5",
                  p: 2,
                  borderRadius: 1,
                  mb: 3,
                  fontFamily: '"Inter", sans-serif',
                  marginTop: 3,
                }}
              >
                <CheckCircle sx={{ color: "green", mr: 2 }} />
                <Typography
                  variant="body2"
                  sx={{ color: "#555", fontSize: "14px" }}
                >
                  Your information is securely handled in compliance with RBI
                  guidelines. We only share your details with verified banking
                  partners.
                </Typography>
              </Box>

              {/* Mobile Number */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, color: "#555", fontSize: "14px" }}
                >
                  Mobile Number
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  value={mobileNumber}
                  onChange={handleMobileChange}
                  placeholder="Enter your mobile number"
                  error={!!mobileError}
                  helperText={mobileError}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      fontSize: "14px",
                    },
                  }}
                />
              </Box>

              {/* PAN Number */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, color: "#555", fontSize: "14px" }}
                >
                  PAN Number <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  value={pan}
                  onChange={handlePanChange}
                  placeholder="e.g., ABCDE1234F"
                  error={!!panError}
                  helperText={panError}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      fontSize: "14px",
                    },
                  }}
                />
              </Box>
              {/* Bank Selection */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, color: "#555", fontSize: "14px" }}
                >
                  Select Bank(s)
                </Typography>

                <FormControl fullWidth>
                  <Select
                    multiple
                    value={selectedBanks}
                    onChange={(e) => setSelectedBanks(e.target.value)}
                    renderValue={(selected) =>
                      selected.map((bank) => bank.name).join(", ")
                    }
                  >
                    {dummyBanks.map((bank) => (
                      <MenuItem key={bank.id} value={bank}>
                        <Checkbox
                          checked={
                            selectedBanks.find((b) => b.id === bank.id) !==
                            undefined
                          }
                        />
                        <ListItemText primary={bank.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              {/* Consent Checkbox */}

              <FormControlLabel
                control={
                  <Checkbox
                    sx={{ top: -32 }}
                    checked={consent}
                    onChange={(e) => setConsent(e.target.checked)}
                  />
                }
                label={
                  <Box sx={{ fontSize: "14px", color: "#555", mb: 3 }}>
                    I consent to share my mobile number and PAN details with
                    trusted banking partners for loan assistance. I understand
                    that bank representatives will contact me regarding loan
                    offers.
                  </Box>
                }
              />

              {/* Action Buttons */}
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="text"
                  sx={{
                    color: "#1570ef",
                    fontSize: "14px",
                    textTransform: "none",
                  }}
                  onClick={handleClose}
                >
                  Back to offers
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#1570ef",
                    color: "white",
                    fontWeight: "bold",
                    borderRadius: 1,
                    "&:hover": { backgroundColor: "#0d5cb6" },
                    fontSize: "14px",
                    textTransform: "none",
                  }}
                  onClick={handleSubmit}
                  disabled={!mobileNumber || !pan || !consent || selectedBanks.length === 0}
                >
                  {loading ? (
                    <CircularProgress size={24} sx={{ color: "white" }} />
                  ) : (
                    "Submit Enquiry"
                  )}
                </Button>
              </Box>
            </>
          ) : (
            /* Success State */
            <Box sx={{ textAlign: "center", py: 4 }}>
              <CheckCircle sx={{ color: "green", fontSize: 40, mb: 2 }} />
              <Typography
                variant="h6"
                sx={{ color: "#555", fontWeight: "bold", fontSize: "20px" }}
              >
                Enquiry Submitted!
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#555", mb: 3, fontSize: "14px" }}
              >
                Thank you for your interest. Our trusted banking partners will
                contact you shortly at your registered mobile number.
              </Typography>
              <Box
                sx={{
                  backgroundColor: "#F5F5F5",
                  p: 2,
                  borderRadius: 1,
                  mb: 3,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "bold", mb: 1, fontSize: "14px" }}
                >
                  What happens next?
                </Typography>
                <ul>
                  <li style={{ fontSize: "14px" }}>
                    You'll receive a confirmation with partner bank details
                  </li>
                  <li style={{ fontSize: "14px" }}>
                    A bank representative will call you within 24-48 hours
                  </li>
                  <li style={{ fontSize: "14px" }}>
                    Complete documentation and get your loan approved
                  </li>
                </ul>
              </Box>
              <Button variant="outlined" onClick={handleClose}>
                Close
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default LoanEnquiryModal;
